module.exports = __webpack_public_path__ + "static/media/1021276.6e2f109e.png";